/* eslint-disable max-len */
import styled from 'styled-components'
import colors from 'globals/colors'

interface StateIconWrapperProps {
  type: 'success' | 'fail'
}

export const StateIconWrapper = styled.div<StateIconWrapperProps>`
    width: 57px;
    height: 57px;
    color: white;
    background-color: ${(props) => props.type === 'success' ? 'rgba(45, 207, 179, 0.1)' : 'rgba(255, 52, 101, 0.097766)'};

    div.ant-modal.confirm-modal {
        width: 502px !important;
    }

    .free-answer-modal-button-wrapper {
        display: flex;
        justify-content: space-between;
    }

    &, & div {
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    & > div {
        width: 43px;
        height: 43px;
        background-color: ${(props) => props.type === 'success' ? 'rgba(45, 207, 179, 0.23)' : 'rgba(255, 52, 101, 0.226138)'};

        & > div {
            width: 27px;
            height: 27px;
            font-size: 16px;
            background-color: ${(props) => props.type === 'success' ? colors.blueGreen : colors.reddishPink};
        }
    }
`
